import { callApi } from "../utils/apiClient";
import { API_ENDPOINTS } from "../config/api/apiCall";

export const salaryCompensationCRUD = async (payload) => {
    try {
        return await callApi(API_ENDPOINTS.SALARY_STRUCTURE_COMPENSATION_CRUD, 'POST', { 'Content-Type': 'application/json' }, payload);
    }
    catch (error) {
        console.error("Error loading shift employee assignment:", error);
        throw error;
    }
};

export const getSalaryCompensationByEmployeeId = async (payload) => {
    try {
        return await callApi(API_ENDPOINTS.SALARY_STRUCTURE_GET_COMPENSATIONS_BY_EMPLOYEE_ID, 'POST', { 'Content-Type': 'application/json' }, payload);
    }
    catch (error) {
        console.error("Error loading shift employee assignment:", error);
        throw error;
    }
};

